import { postEvent } from '@tma.js/sdk';

type PostEventArgs = Parameters<typeof postEvent>;
export const postEventSafe: typeof postEvent = (
  ...args: PostEventArgs
) => {
  try {
    postEvent(...args);
  } catch (e) {
    console.error(e);
  }
};
